// 浮点处理
const clac = function (op, x, y) {
    const n = { '*': x * y, '-': x - y, '+': x + y, '/': x / y }[op];
    return Math.round(n * 100) / 100;
};
// 平均处理
const average = (t, c) => {
    const averageArr = Array.from({ length: c }, () => {
        return clac('/', t, c);
    });

    const sum = averageArr.reduce((a, v) => {
        return a + v;
    }, 0);

    if (t > sum) {
        averageArr[averageArr.length - 1] = clac('+', clac('-', t, sum), averageArr[averageArr.length - 1]);
        return averageArr;
    }
    if (t < sum) {
        averageArr[averageArr.length - 1] = clac('-', averageArr[averageArr.length - 1], clac('-', sum, t));
        return averageArr;
    }
    return averageArr;
};

export { clac, average };
